export default __webpack_public_path__ + "static/upCity-12fb7129fa8389f37ab2cf43316d590a.png";